import api from '../axiosInstance'

export const createPlan = (planData) => {
  try {
    const response = api.post('/plans', planData)
    console.log('Plan created:', response.data)
    return response.data
  } catch (error) {
    console.error('Error creating plan:', error)
    throw error
  }
}

export const getPlanById = async (planId) => {
  try {
    const response = await api.get(`/plans/${planId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching plan by ID:', error)
    throw error
  }
}

export const getPlans = async () => {
  try {
    const response = await api.get('/plans')
    return response.data
  } catch (error) {
    console.error('Error fetching plans:', error)
    throw error
  }
}

export const updatePlan = async (planId, planData) => {
  try {
    const response = await api.patch(`/plans/${planId}`, planData)
    return response.data
  } catch (error) {
    console.error('Error updating plan:', error)
    throw error
  }
}

export const deletePlan = async (planId) => {
  try {
    await api.delete(`/plans/${planId}`)
  } catch (error) {
    console.error('Error deleting plan:', error)
    throw error
  }
}